import EmtyStateImage from "~/images/empty-schedule.jpg";
import { Flex } from "~/components/Flex";
import { Box, Typography } from "@mui/material";

export const SecurityPipelineOverviewEmptyState = () => {
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={2}
      sx={{
        position: "relative",
      }}
    >
      <Box
        sx={{
          height: "300px",
          width: "100%",
          background: `url(${EmtyStateImage}) lightgray 50% / cover no-repeat`,
          filter: "blur(6px)",
        }}
      />
      <Typography
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          textAlign: "center",
        }}
        color="text.secondary"
        variant="h4"
        fontWeight={700}
      >
        Select findings, or setup a fix schedule to track your fixes
      </Typography>
    </Flex>
  );
};
